module.exports = __webpack_public_path__ + "static/media/pin_circle_background_icon.d0df8b24.png";